import React from 'react';

interface Props {
  selectedIds: string[];
  onMarkDone: () => void;
  onUnselect: () => void;
  busy: boolean;
}

/**
 * Floating action bar that appears at the bottom of the viewport
 * whenever tasks are selected in the project task list.
 */
export function BulkActionBar({ selectedIds, onMarkDone, onUnselect, busy }: Props) {
  if (selectedIds.length === 0) return null;

  return (
    <div className="bulk-action-bar">
      <span className="bulk-count">{selectedIds.length} selected</span>
      <button
        className="btn btn-primary btn-sm"
        disabled={busy}
        onClick={onMarkDone}
      >
        {busy ? '…' : '✅ Mark Done'}
      </button>
      <button
        className="btn btn-ghost btn-sm"
        onClick={onUnselect}
      >
        ✕ Deselect All
      </button>
    </div>
  );
}
